import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './FJItem.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJTextToSpeechPlayItem from '../../../../common/components/audio/FJTextToSpeechPlayItem/FJTextToSpeechPlayItem.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJStringUtil from '../../../../util/FJStringUtil.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';

const FJItem = props => {
    const { index, info = {}, updateIsPlay, updateCurrentTime, onPlayClick, onEnded } = props;
    const { generationType, text, audioDuration } = info;

    const _audioPlayRef = useRef(null);

    const _dealData = () => {
        switch (generationType) {
            case FJConstant.MICROSOFT: {
                const { audioUrl, voiceInfo } = info;
                const { value, name } = voiceInfo;
                return {
                    audioUrl: audioUrl,
                    avatarUrl: FJStringUtil.getTextToSpeechImgUrl(value),
                    name: name,
                };
            }
            case FJConstant.CLONE_BY_SELF: {
                const { voiceInfo, audioUrl } = info;
                const { name } = voiceInfo;
                return {
                    audioUrl: audioUrl,
                    avatarUrl: voiceInfo.imgUrl,
                    name: name,
                };
            }
            case FJConstant.CLONE_BY_FLEX_CLIP: {
                const { voiceInfo, audioUrl } = info;
                const { name, value } = voiceInfo;
                return {
                    audioUrl: audioUrl,
                    avatarUrl: FJTextToSpeechUtil.getVoiceStyleImgUrl(value),
                    name: name,
                };
            }
            default:
        }
    };
    const { audioUrl, avatarUrl, name } = _dealData();

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.TTV_CHANGE_PLAY, playId => {
            if (playId === info.id) {
                _audioPlayRef.current.play();
            }
        });
        return () => {
            un();
        };
    }, []);

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.TTV_STOP_PLAY, playId => {
            if (playId === info.id) {
                _audioPlayRef.current.reset();
            }
        });
        return () => {
            un();
        };
    }, []);

    return (
        <div className={styles.box}>
            <div className={styles.title}>{FJLocalStore._('section-xxx').replace('xxx', index)}</div>
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.left}>
                        <FJTextToSpeechPlayItem
                            audioUrl={audioUrl}
                            updateIsPlay={updateIsPlay}
                            updateCurrentTime={updateCurrentTime}
                            ref={_audioPlayRef}
                            onPlayClick={onPlayClick}
                            onEnded={onEnded}
                        />
                        <div className={styles.img_box}>
                            <img src={avatarUrl} alt='' />
                        </div>
                        <FJTextWithEllipsis className={styles.name} text={name} />
                    </div>
                    <div className={styles.time}>{FJUtil.formatTime(audioDuration, false, 2)}</div>
                </div>
                <div className={styles.desc}>{text}</div>
            </div>
        </div>
    );
};
FJItem.propTypes = {
    index: PropTypes.number,
    info: PropTypes.object,
    updateIsPlay: PropTypes.func,
    updateCurrentTime: PropTypes.func,
    onPlayClick: PropTypes.func,
    onEnded: PropTypes.func,
};
export default FJItem;
